import { EditIcon } from 'components/Icon'
import CopyBtn from 'components/CopyBtn'
import { BasicInputGroup } from 'components/UserInputs'
import { TeacherSearchInput } from 'components/UserInputs/TeacherSearchInput'
import { useBoolean } from 'hooks'
import { useEffect } from 'react'
import { Box, Flex } from 'theme-ui'
import { TeacherData, ViewMode } from 'types'

export type TeacherInfoSectionProps = {
  teacher: {
    id: string
    email: string
    forename: string
    surname: string
  }
  changeTeacher: (teacher: TeacherData) => void
  viewMode: ViewMode
}

export const TeacherInfoSection = ({
  teacher,
  changeTeacher,
  viewMode,
}: TeacherInfoSectionProps) => {
  const [
    showTeacherSearch,
    ,
    closeTeacherSearch,
    toggleTeacherSearch,
  ] = useBoolean(false)

  const handleChangeTeacher = (teacher: TeacherData) => {
    changeTeacher(teacher)
    closeTeacherSearch()
  }
  useEffect(() => {
    viewMode === 'view' && closeTeacherSearch()
  }, [viewMode, closeTeacherSearch])
  const teacherName = teacher.forename
    ? `${teacher.forename} ${teacher.surname}`
    : ''

  const teacherDetailsDisplay = (
    <Box>
      <Box sx={{ pt: 1 }}>{teacherName}</Box>
      <Box sx={{ pt: 1 }}>
        <Flex sx={{ mb: -2 }}>
          {teacher.email}

          <Flex sx={{ mb: -2 }}>
            <Box sx={{ ml: 3 }}>
              <CopyBtn
                copyText={teacher.email}
                copyTextName="Email"
                size={24}
              />
            </Box>
          </Flex>
        </Flex>
      </Box>
      {viewMode === 'edit' && !showTeacherSearch && (
        <Box
          onClick={toggleTeacherSearch}
          sx={{
            color: 'textPrimary',
            cursor: 'pointer',
            fontWeight: 600,
            pt: 4,
            display: 'flex',
            alignItems: 'center',
          }}>
          <EditIcon
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              pr: '5px',
            }}
          />
          Edit
        </Box>
      )}
    </Box>
  )

  return (
    <>
      <Flex variant={`forms.section.fullWidth`}>
        <Box sx={{ mb: -20 }}>
          <BasicInputGroup
            name="teacherDetails"
            label="Teacher details"
            display={teacherDetailsDisplay}
            disabled={true}
            copyableText={teacher.id}
            copyableTextName="Teacher ID"
            input={<></>}
          />
        </Box>
      </Flex>
      {showTeacherSearch && viewMode === 'edit' && (
        <Flex variant={`forms.section.fullWidth`} sx={{}}>
          <Box
            sx={{
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: [335, 640],
            }}>
            <TeacherSearchInput onTeacherPicked={handleChangeTeacher} />
          </Box>
        </Flex>
      )}
    </>
  )
}
